// extracted by mini-css-extract-plugin
module.exports = {"container":"CardBonusChip_container__NKyTE","link":"CardBonusChip_link__gvShn","icon":"CardBonusChip_icon__weQvx"};